import axios from 'axios'
import getUrlKey from '@/utils/getUrlKey'
import md5 from 'js-md5'
import { Toast } from 'mint-ui'

// export const openId = getUrlKey(window.location.href).openid || 'o0yuK5arz5LL9KthN2E7jEFV0FZA'
// 商户Id
// console.log(getUrlKey(window.location.search), '打印获取到的')
export const merchantId = getUrlKey(window.location.search).merchantId
    // export const merchantId = 3837
    // export const uid = getUrlKey(window.location.href).uid.split("#/")[0]
export const uid = 0

export const token = decodeURIComponent(getUrlKey(window.location.href).token)
    // 判断是否是H5
export const way = getUrlKey(window.location.search).from
    // 配置超时时间
const service = axios.create({
    baseURL: process.env.BASE_API, // api 的 base_url
    timeout: 10000 // request timeout
})

service.interceptors.request.use(
    config => {
        config.headers['ak'] = '999'
        if (merchantId) {
            config.headers['ak'] = '999'
            config.headers['token'] = token
            config.headers['data'] = `{"merchant_id":${merchantId},"uid":${uid}}`
            config.headers['time'] = new Date()
                .getTime()
                .toString()
                .substr(0, 10)
            const temp =
                '1002' +
                '9ad96eb8f271a358' +
                // `merchant_id${merchantId}uid${uid}` +
                new Date()
                .getTime()
                .toString()
                .substr(0, 10)
            config.headers['sign'] = md5(temp)
        }
        return config
    },
    error => {
        // Do something with request error
        console.log(error, 'error debug') // for debug
        Promise.reject(error)
    }
)

service.interceptors.response.use(
    /**
     * 下面的注释为通过在response里，自定义code来标示请求状态
     * 当code返回如下情况则说明权限有问题，登出并返回到登录页
     * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
     * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
     */
    response => {
        const res = response.data
            // return response.data
        if (res.success) {
            // 成功返回resolve数据
            return Promise.resolve(response.data)
        } else {
            Toast(res.data.message)
                // 失败success为flase 返回reject数据
            return Promise.reject(response.data)
        }
    },
    error => {
        Toast(res.data.message)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/api/request.js